import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import ant_zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import ant_en_US from 'ant-design-vue/lib/locale-provider/en_US';
// import 'moment/locale/zh-cn';
// import 'moment/locale/en-us';


import enLocale from './language.en_US'
import zhLocale from './language.zh_CN'

Vue.use(VueI18n)

const messages = {
  en_US: {
    ...enLocale,
    ...ant_en_US
  },
  zh_CN: {
    ...zhLocale,
    ...ant_zh_CN
  }
}

const i18n = new VueI18n({
  // 设置语言 选项 en_US | zh_CN
  locale: Cookies.get('language') || 'zh_CN', // 通过this.$i18n.locale的值实现语言切换
  // 设置文本内容
  messages
})

export default i18n
